import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { Address } from '../../../../entities/shared/address';

@MergeSchema({
    entity: ActivityEntityName.Account
})
export class AccountMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField()
    legalName: string;

    @MergeField()
    phone: string;

    @MergeField()
    email: string;

    @MergeField({ hidden: true })
    primaryContactId;

    @MergeField({ hidden: true })
    primarySiteId: string;

    @MergeField()
    taxId: string

    @MergeField()
    street1: string;

    @MergeField()
    street2: string;

    @MergeField()
    suburb: string;

    @MergeField()
    county: string;

    @MergeField()
    state: string;

    @MergeField()
    postalCode: string;

    @MergeField()
    country: string;

    @MergeField()
    fullAddress: string;

    @MergeField()
    primarySiteName: string;

    @MergeField()
    creditAccountType: string;

    @MergeField()
    creditLimitAmount: number;

    @MergeField()
    creditOutstandingInvoicesAmount: number;

    @MergeField()
    creditOverdueInvoicesAmount: number;

    customFields: any;

    address: Address;
}

export const AccountMergeSchema = getSchema(AccountMergeData);

export const contactMergeDataFromAccount = (account: AccountMergeData) => {
    return {
        _id: account._id,
        name: account.name,
        phone: account.phone,
        mobile: null,
        email: account.email,
        legalName: account.legalName
    };
};